import React from 'react';
import Column from '../Column';

const Header = ({
    columns,
    className,
}) => (
    <div className={className}>
        {
            columns.map(({ key, label }) => (
                <Column
                    key={key}
                    html={label}
                />
            ))
        }
    </div>
);

export default Header;